(function() {
  'use strict';

  /**
   * @ngdoc directive
   * @name webAgro1App.directive:widgetestacaometeorologica
   * @description
   * # widgetestacaometeorologica
   */
  angular
    .module('webAgro1App')
    .directive('widgetEstacaoMeteorologica', WidgetEstacaoMeteorologica);

  /**
   * Declare Widget Estação Meteorológica
   * @return {Object}
   */
  function WidgetEstacaoMeteorologica() {

    //////////////////////////////////////////
    // Directive definition object
    var directive = {
      templateUrl: 'views/widgets/estacao-meteorologica/view.html',
      restrict: 'A',
      controller: 'WidgetEstacaoMeteorologicaCtrl',
      controllerAs: 'wctrl',
      scope: {
        widget: '=data'
      }
    };
    return directive;

  }

}());
